import { useFormContext } from 'react-hook-form'
import { classNames } from 'utils/classNames'
import { ErrorMessage } from './ErrorMessage'

type Props = {
  label?: string
  name: string
  required?: boolean
  disabled?: boolean
}

export const InputValue = (props: Props) => {
  const { label, required = false, disabled = false, name } = props
  const { register } = useFormContext()

  const baseStyle =
    'w-full rounded border border-[#ddd] px-3 py-2 text-sm outline-none'
  const disabledStyle = 'bg-gray-50 text-gray-500'
  return (
    <div className="relative flex flex-col">
      {label && (
        <label className={'mb-1.5 block text-sm font-medium text-[#555]'}>
          {label}
          {required && <span className={'text-red-500'}>{' *'}</span>}
        </label>
      )}
      <input
        {...register(name, {
          setValueAs: (v: unknown) =>
            v === '' || v === undefined ? undefined : Number(v)
        })}
        className={classNames([
          baseStyle,
          disabled ? disabledStyle : '',
          'focus:border-b-teal-400'
        ])}
        type={'number'}
        disabled={disabled}
      />
      <ErrorMessage name={name} />
    </div>
  )
}
